import { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "../style/AddEmployee.css";
import logo from "../assets/logo.png";
import { NavLink } from "react-router-dom";

export default function AddEmployee() {
  const navigate = useNavigate();
  const location = useLocation();
  const isEdit = Boolean(location.state);
  // const [createLogin, setCreateLogin] = useState(true);
  // const [status, setStatus] = useState("Enabled");

  const [form, setForm] = useState({
    firstName: "",
    middleName: "",
    lastName: "",
    employeeId: "",
    job: "",
    status: "",
    image: "",
    createLogin: false,
  });

  /* ===== PREFILL FOR EDIT ===== */
  useEffect(() => {
    if (isEdit) {
      const emp = location.state;
      const nameParts = emp.name.split(" ");

      setForm({
        firstName: nameParts[0] || "",
        middleName: nameParts.slice(1, -1).join(" "),
        lastName: nameParts.at(-1) || "",
        employeeId: emp.id,
        job: emp.job,
        status: emp.status,
        image: emp.image || "",
        createLogin: false,
      });
    }
  }, [isEdit, location.state]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setForm({
      ...form,
      [name]: type === "checkbox" ? checked : value,
    });
  };

  const handleImage = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    if (file.size > 1024 * 1024) {
      alert("Image must be under 1MB");
      return;
    }

    const reader = new FileReader();
    reader.onloadend = () => {
      setForm({ ...form, image: reader.result });
    };
    reader.readAsDataURL(file);
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!form.firstName || !form.lastName || !form.employeeId) {
      alert("Please fill required fields");
      return;
    }

    const employeeData = {
      id: form.employeeId,
      name: `${form.firstName} ${form.middleName} ${form.lastName}`.replace(
        /\s+/g,
        " "
      ),
      job: form.job || "—",
      status: form.status,
      image: form.image,
    };

    const existing =
      JSON.parse(localStorage.getItem("employees")) || [];

    let updatedEmployees;

    if (isEdit) {
      updatedEmployees = existing.map((emp) =>
        emp.id === employeeData.id ? employeeData : emp
      );
    } else {
      updatedEmployees = [...existing, employeeData];
    }

    localStorage.setItem(
      "employees",
      JSON.stringify(updatedEmployees)
    );

    navigate("/employee-list");
  };

  return (
    <div className="add-employee-page">

{/* Side bar */}
  <aside className="sidebar">
      {/* ===== LOGO ===== */}
      <div className="sidebar-logo">
        <img src={logo} alt="OrangeHRM" />
      </div>

      {/* ===== MENU ===== */}
      <ul className="employee-menu">
        <li>
          <NavLink to="/search" className="menu-item">
            <span className="icon">🔍</span>
            <span>Search</span>
          </NavLink>
        </li>

        <li>
          <NavLink to="/admin" className="menu-item">
            <span className="icon">👤</span>
            <span>Admin</span>
          </NavLink>
        </li>

        <li>
          <NavLink
            to="/employee-list"
            className={({ isActive }) =>
              isActive ? "menu-item active" : "menu-item active"
            }
          >
            <span className="icon">👥</span>
            <span>PIM</span>
          </NavLink>
        </li>

        <li>
          <NavLink to="/leave-list" className="menu-item">
            <span className="icon">📝</span>
            <span>Leave</span>
          </NavLink>
        </li>

        <li>
          <NavLink to="/time" className="menu-item">
            <span className="icon">⏱</span>
            <span>Time</span>
          </NavLink>
        </li>

        <li>
          <NavLink to="/recruitment" className="menu-item">
            <span className="icon">🎯</span>
            <span>Recruitment</span>
          </NavLink>
        </li>

        <li>
          <NavLink to="/my-info" className="menu-item">
            <span className="icon">📄</span>
            <span>My Info</span>
          </NavLink>
        </li>

        <li>
          <NavLink to="/performance" className="menu-item">
            <span className="icon">⭐</span>
            <span>Performance</span>
          </NavLink>
        </li>

        <li>
          <NavLink to="/dashboard" className="menu-item">
            <span className="icon">🏠</span>
            <span>Dashboard</span>
          </NavLink>
        </li>

        <li>
          <NavLink to="/directory" className="menu-item">
            <span className="icon">📇</span>
            <span>Directory</span>
          </NavLink>
        </li>

        <li>
          <NavLink to="/maintenance" className="menu-item">
            <span className="icon">⚙️</span>
            <span>Maintenance</span>
          </NavLink>
        </li>

        <li>
          <NavLink to="/claim" className="menu-item">
            <span className="icon">💰</span>
            <span>Claim</span>
          </NavLink>
        </li>

        <li>
          <NavLink to="/buzz" className="menu-item">
            <span className="icon">💬</span>
            <span>Buzz</span>
          </NavLink>
        </li>
      </ul>
    </aside>

<main className="main-content">

      <div className="add-employee-card">
        <h3>{isEdit ? "Edit Employee" : "Add Employee"}</h3>
        <hr />

        <form onSubmit={handleSubmit}>
          <div className="form-body">
            {/* ===== IMAGE SECTION ===== */}
            <div className="image-section">
              <div
                className={`image-circle ${
                  form.image ? "has-image" : ""
                }`}
              >
                {form.image && (
                  <img src={form.image} alt="Profile" />
                )}

                <label className="image-add-btn">
                  +
                  <input
                    type="file"
                    hidden
                    accept="image/*"
                    onChange={handleImage}
                  />
                </label>
              </div>

              <p>
                Accepts jpg, png, gif up to 1MB. <br />
                Recommended: 200x200
              </p>
            </div>

            {/* ===== FORM SECTION ===== */}
            <div className="form-section">
              <label>
                Employee Full Name <span>*</span>
              </label>

              <div className="name-row">
                
                <input
                  name="firstName"
                  placeholder="First Name"
                  value={form.firstName}
                  onChange={handleChange}
                />
                <input
                  name="middleName"
                  placeholder="Middle Name"
                  value={form.middleName}
                  onChange={handleChange}
                />
                <input
                  name="lastName"
                  placeholder="Last Name"
                  value={form.lastName}
                  onChange={handleChange}
                />
              </div>
<div >
              <label>
                Employee Id <span>*</span>
              </label>
              <input
                name="employeeId"
                placeholder="EMP003"
                value={form.employeeId}
                onChange={handleChange}
                disabled={isEdit}
              />
</div>
<br/>
<div>
              <label>Job Title</label>
              <input
                name="job"
                placeholder="Software Engineer"
                value={form.job}
                onChange={handleChange}
              />
</div>
<br/>
<div>
              <label>Status</label>
              <select
                name="status"
                value={form.status}
                onChange={handleChange}
              >
                   <option>-- Select -- </option>
                <option>Full-Time</option>
                <option>Part-Time</option>
                <option>Contract</option>
              </select>
              </div>  
            </div>
          </div>

          <hr />

          {/* ===== TOGGLE ===== */}
{/* Toggle */}
<div className="toggle-row">
  <span>Create Login Details</span>

  <label className="switch">
    <input
      type="checkbox"
      name="createLogin"
      checked={form.createLogin}
      onChange={handleChange}
    />
    <span className="slider"></span>
  </label>
</div>

{/* CREATE USER SECTION */}
{form.createLogin && (
  <div className="create-user-section">
    <div className="form-grid">
      <div className="form-group">
        <label>Username<span>*</span></label>
        <input
          type="text"
          name="username"
          value={form.username}
          onChange={handleChange}
        />
      </div>

      <div className="form-group">
        <label>Status</label>
        <div className="radio-group">
          <label className="radio">
            <input
              type="radio"
              name="status"
              value="Enabled"
              checked={form.status === "Enabled"}
              onChange={handleChange}
            />
            <span></span>
            Enabled
          </label>

          <label className="radio">
            <input
              type="radio"
              name="status"
              value="Disabled"
              checked={form.status === "Disabled"}
              onChange={handleChange}
            />
            <span></span>
            Disabled
          </label>
        </div>
      </div>
    </div>

    <div className="form-grid">
      <div className="form-group">
        <label>Password<span>*</span></label>
        <input
          type="password"
          name="password"
          value={form.password}
          onChange={handleChange}
        />
      </div>

      <div className="form-group">
        <label>Confirm Password<span>*</span></label>
        <input
          type="password"
          name="confirmPassword"
          value={form.confirmPassword}
          onChange={handleChange}
        />
      </div>
    </div>

    <p className="password-hint">
      For a strong password, please use upper & lower case letters, numbers and symbols.
    </p>
  </div>
)}


          <hr />

          {/* ===== FOOTER ===== */}
          <div className="form-footer">
            <span className="required-text">* Required</span>
            <div className="footer-buttons">
              <button
                type="button"
                className="cancel-btn"
                onClick={() => navigate("/employee-list")}
              >
                Cancel
              </button>
              
              <button type="submit" className="save-btn">
                Save
              </button>
            </div>
          </div>
        </form>
      </div>
      </main>
    </div>
  );
}
